<template>
  <div class="main">
    <el-tabs v-model="activeName" type="border-card" style="width: 100%;">
      <el-tab-pane label="报警列表" name="first">
        <!-- Right -->
        <div class="main_r">
          <!-- search -->
          <div class="search">
            <div>
              <el-input v-model="queryData.deviceSn"  placeholder="请输入设备编号"></el-input>
              <el-date-picker v-model="queryData.timeBegin" type="date" value-format="yyyy-MM-dd" placeholder="起始时间" class="mr15"></el-date-picker>
              <el-date-picker v-model="queryData.timeEnd" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
              <el-button type="primary" @click="clickQuery">查询</el-button>
              <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
            </div>
          </div>
          <!-- search End -->

          <!-- 列表 -->
          <el-table :data="dataList" class="mt15" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" @sort-change="handleSortChange">
            <el-table-column prop="id" label="序号" min-width="5%" sortable="custom"></el-table-column>
            <el-table-column prop="deviceSn" label="设备编号" min-width="15%" sortable="custom"></el-table-column>
            <el-table-column prop="errcode" label="报警码" min-width="15%" sortable="custom"></el-table-column>
            <el-table-column prop="errmsg" label="报警原因" min-width="25%" sortable="custom"></el-table-column>
            <el-table-column prop="remark" label="备注" min-width="15%" sortable="custom"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="15%" sortable="custom"></el-table-column>
            <el-table-column label="操作" min-width="10%">
              <template slot-scope="scope">
                <el-button type="danger" size="mini" @click="clickDelete(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="mt20">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page_no"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="page_size"
              layout="prev, pager, next, sizes, jumper "
              :total="dataListnum">
            </el-pagination>
          </div>
          <!-- 分页 End -->
        </div>
        <!-- Right End -->
      </el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: { },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      queryData: {
        deviceSn: '',
        timeBegin: '',
        timeEnd: ''
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 10,
      sortField: '',
      sortOrder: ''
    }
  },
  mounted () {
    this.DeviceAlarmList()
    this.DeviceAlarmNum()
  },
  methods: {
    handleSizeChange (val) {
      this.page_size = val
      this.DeviceAlarmList()
      this.DeviceAlarmNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.DeviceAlarmList()
      this.DeviceAlarmNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.DeviceAlarmList()
      this.DeviceAlarmNum()
    },
    clickQuery () {
      this.page_no = 1
      this.DeviceAlarmList()
      this.DeviceAlarmNum()
    },
    clickQueryReset () {
      this.queryData.deviceSn = ''
      this.queryData.timeBegin = ''
      this.queryData.timeEnd = ''
      this.clickQuery()
    },
    DeviceAlarmList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceSn = that.queryData.deviceSn
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceAlarmList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
          console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    DeviceAlarmNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.deviceSn = that.queryData.deviceSn
      data.timeBegin = that.queryData.timeBegin
      data.timeEnd = that.queryData.timeEnd
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_DeviceAlarmNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    clickDelete (row) {
      var that = this
      this.$confirm('确定删除该报警记录吗？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var data = Vue.prototype.FunGetBaseSignData()
        data.id = row.id
        data.sign = Vue.prototype.FunGetSign(data)
        axios.post(Vue.prototype.global.Url_DeviceAlarmDelete, Qs.stringify(data))
          .then(function (response) {
            if (response.data.code === 1) {
              Vue.prototype.$message.success('删除成功')
              that.DeviceAlarmList()
              that.DeviceAlarmNum()
            } else {
              Vue.prototype.FunRemindAllways(response.data.msg)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }).catch(function () {
        // 用户取消删除
      })
    }
  }
}
</script>

<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;

  .el-input {
    width: 150px;
    margin-right: 15px;
  }

  .el-select{
    width: 150px;
    margin-right: 15px;
  }
}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 120px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}
</style>

<style scoped>
::v-deep .el-tabs__content {
  padding: 5px;
}
</style>
